export const FUNCTIONALITY = Object.freeze({
    CAMPAIGN: "campaign_manager",
    USER: "user_manager",
    ZONE: "zone_manager"
});



// WEBPACK FOOTER //
// ./src/components/tools/constants.js